import React from 'react'
import PropTypes from 'prop-types'
import adaptativoLogoFile from '../../assets/img/logo_adaptativo.png'
import redeProfLogoFile from '../../assets/img/rede_prof.png'
import redePitagorasLogoFile from '../../assets/img/rede_pitagoras.png'
import bancoDeQuestoesLogoFile from '../../assets/img/banco_de_questoes.png'

import {
  container,
  systemImage,
  systemLink
} from './styles/SystemLinksList.style.js'

export const urls = {
  local: {
    vitalis: 'http://localhost:3001',
    sapientia: 'http://localhost:3001',
    obecon: 'http://localhost:3001'
  },

  staging: {
    adaptive: 'https://staging-admin.profapp.com.br',
    profNetwork: 'https://staging.redeprof.com',
    profNetworkPitagoras: 'https://staging-pitagoras.redeprof.com',
    databaseQuestions: 'https://staging.bancodequestoes.net',
    vitalis: 'https://stag-app.olimpiadademedicina.org/',
    sapientia: 'https://stag-app.olimpiadadofuturo.com.br/',
    obecon: 'https://stag-app.obecon.org/',
    pocket: 'https://stag-app.olimpiadapocket.com.br/',
    obling: 'https://stag-app.obling.com.br',
    mncti: 'https://stag-app.mncti.com.br/',
    opecon: 'https://stag-app.olimpiadasdaeconomia.com/',
    celeritas: 'https://stag-app.olimpiadadeia.org/',
    redacao: 'https://explore.plataformaverbo.com.br/auth/sso/login',
    verbo: 'https://explore.plataformaverbo.com.br/auth/sso/login',
    obbs: 'https://stag-app.olimpiadadebiologiasintetica.org/',
    opmbr: 'https://stag-app.opmbr.org/',
    bertoni: 'https://stag-bertoni.plataformaversar.com.br/',
    kingdom: 'https://stag-versar.mykingdomschool.com.br/',
    versar: 'https://stag-app.plataformaversar.com.br/',
    soma: 'https://stag-app.plataformasoma.net/',
    serios: 'https://stag-agenda.serios.academy/',
    versarHomolog: 'https://homolog-app.plataformaversar.com.br',
    adminProfHomolog: 'https://homolog-admin.profapp.com.br',
    adminProf: 'https://staging-admin.profapp.com.br',
    esc: 'https://stag-esc.plataformaversar.com.br/',
    profSerios: 'https://staging-aluno.colegioserios.com.br/',
    profAtrio: 'https://staging-app.alunoatrio.com.br/',
    ligaOlimpiadas: 'https://stag-app.ligadasolimpiadas.com.br',
    fronteiras: 'https://stag-app.fronteirasdaeducacao.com.br',
    mundoKids: 'https://stag-mundokids.plataformaversar.com.br',
    verboSerios: 'https://stag-alunoserios.plataformaverbo.com.br',
    verboEducandario: 'http://stag-alunoeducandario.plataformaverbo.com.br',
    verboAtrio: 'https://stag-alunoatrio.plataformaverbo.com.br',
    verboCapacitacao: 'http://stag-alunocapacitacao.plataformaverbo.com.br',
    verboCope: 'http://stag-alunocope.plataformaverbo.com.br',
    verboGalois: 'http://stag-alunogalois.plataformaverbo.com.br',
    verboLavemOENEM: 'http://stag-alunolavemoenem.plataformaverbo.com.br',
    verboPPA: 'http://stag-alunoppa.plataformaverbo.com.br',
    verboRedacaoSolidaria: 'http://stag-alunoredacaosolidaria.plataformaverbo.com.br',
    verboNations: 'https://stag-alunonations.plataformaverbo.com.br'
  },
  production: {
    adaptive: 'https://admin.profapp.com.br/',
    profNetwork: 'https://redeprof.com',
    profNetworkPitagoras: 'https://pitagoras.redeprof.com',
    databaseQuestions: 'https://staging.bancodequestoes.net',
    vitalis: 'https://app.olimpiadademedicina.org/',
    sapientia: 'https://app.olimpiadadofuturo.com.br/',
    obecon: 'https://app.obecon.org/',
    pocket: 'https://app.olimpiadapocket.com.br/',
    obling: 'https://app.obling.com.br/',
    mncti: 'https://app.olimpiadabrasil.org',
    opecon: 'https://app.olimpiadasdaeconomia.com/',
    celeritas: 'https://app.olimpiadadeia.org/',
    redacao: 'https://app.redacaosolidaria.org/auth/sso/login',
    verbo: 'https://app.plataformaverbo.com.br/auth/sso/login',
    obbs: 'https://app.olimpiadadebiologiasintetica.org/',
    opmbr: 'https://app.opmbr.org/',
    bertoni: 'https://bertoni.plataformaversar.com.br/',
    esc: 'https://esc.plataformaversar.com.br/',
    kingdom: 'https://versar.mykingdomschool.com.br/',
    versar: 'https://app.plataformaversar.com.br/',
    soma: 'https://app.plataformasoma.net/',
    serios: 'https://agenda.serios.academy/',
    profSerios: 'https://aluno.colegioserios.com.br/',
    profAtrio: 'https://app.alunoatrio.com.br/',
    ligaOlimpiadas: 'https://app.ligadasolimpiadas.com.br',
    fronteiras: 'https://app.fronteirasdaeducacao.com.br',
    mundoKids: 'http://mundokids.plataformaversar.com.br',
    verboSerios: 'https://alunoserios.plataformaverbo.com.br',
    verboEducandario: 'http://alunoeducandario.plataformaverbo.com.br',
    verboAtrio: 'https://alunoatrio.plataformaverbo.com.br',
    verboCapacitacao: 'http://alunocapacitacao.plataformaverbo.com.br',
    verboCope: 'http://alunocope.plataformaverbo.com.br',
    verboGalois: 'http://alunogalois.plataformaverbo.com.br',
    verboLavemOENEM: 'http://alunolavemoenem.plataformaverbo.com.br',
    verboPPA: 'http://alunoppa.plataformaverbo.com.br',
    verboRedacaoSolidaria: 'http://alunoredacaosolidaria.plataformaverbo.com.br',
    verboNations: 'https://alunonations.plataformaverbo.com.br'
  }
}

export const env = process.env.REACT_APP_SERVER_ENV === 'production' ? 'production' : process.env.REACT_APP_SERVER_ENV === 'staging' ? 'staging' : 'local'

const SystemLinksList = ({ children }) => (
  <div className={container}>
    <a className={systemLink} href={urls[env].adaptive}>
      <img
        className={systemImage}
        src={adaptativoLogoFile}
        alt='Adaptativo Admin'
      />
    </a>

    <a className={systemLink} href={urls[env].profNetwork}>
      <img
        className={systemImage}
        src={redeProfLogoFile}
        alt='Rede Prof'
      />
    </a>

    <a className={systemLink} href={urls[env].profNetworkPitagoras}>
      <img
        className={systemImage}
        src={redePitagorasLogoFile}
        alt='Rede Pitagoras'
      />
    </a>

    <a className={systemLink} href={urls[env].databaseQuestions}>
      <img
        className={systemImage}
        src={bancoDeQuestoesLogoFile}
        alt='Banco de Questões'
      />
    </a>
  </div>
)

SystemLinksList.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.array
  ])
}

export default SystemLinksList
